export default __webpack_public_path__ + "static/media/FOTO-05.37c0520d.jpg";